/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getDrafts.defs.js'
export { main as default } from './getDrafts.defs.js'
